import React from "react";

//Import Assets
import "./badge.scss";
import {BADGES_TYPE} from "../../../constants/constType";
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";

function Badge(props) {
    const {type, staticTexts} = props
    const badge = BADGES_TYPE[type];
    return badge ? <div className={'badge'}
                         style={{
                             backgroundColor: badge.bgColor,
                             color: badge.textColor,
                         }}>
        {staticTexts?.[badge?.staticKey]}
    </div>:""
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',

    ])
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Badge);
